import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";

const HeroSection = () => {
  const canvasRef = useRef(null);
  const [industry, setIndustry] = useState("Healthcare");
  const [highlightedCard, setHighlightedCard] = useState(0);
  const industries = [
    "Healthcare",
    "Manufacturing",
    "Supply Chain",
    "Aerospace",
    "Energy",
    "HR",
    "Finance",
    "Retail",
  ];

  // Dynamic text rotation for industries
  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % industries.length;
      setIndustry(industries[index]);
    }, 2000); // Change every 2 seconds

    return () => clearInterval(interval);
  }, []);

  // Highlight cards in a loop
  useEffect(() => {
    const interval = setInterval(() => {
      setHighlightedCard((prev) => (prev + 1) % 3);
    }, 3000); // Highlight a new card every 3 seconds

    return () => clearInterval(interval);
  }, []);

  // Three.js sine wave animation
  useEffect(() => {
    const canvas = canvasRef.current;

    // Scene, Camera, and Renderer
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.position.z = 10;

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);

    // Create Sine Wave Geometry
    const createSineWave = (amplitude, frequency, offset, color) => {
      const waveMaterial = new THREE.LineBasicMaterial({ color });
      const waveGeometry = new THREE.BufferGeometry();
      const points = [];
      const originalXs = [];

      for (let x = -50; x <= 50; x += 0.1) {
        originalXs.push(x);
        points.push(
          new THREE.Vector3(x, Math.sin(x * frequency + offset) * amplitude, 0)
        );
      }

      waveGeometry.setFromPoints(points);
      return { wave: new THREE.Line(waveGeometry, waveMaterial), originalXs };
    };

    // Add Multiple Sine Waves
    const waves = [];
    const waveColors = [0xff36e0, 0xff36e0, 0xff36e0];
    for (let i = 0; i < 3; i++) {
      const amplitude = 0.5 + i * 0.2;
      const frequency = 0.2 + i * 0.05;
      const offset = (i * Math.PI) / 4;
      const { wave, originalXs } = createSineWave(
        amplitude,
        frequency,
        offset,
        waveColors[i]
      );
      wave.position.y = -1 + i * 0.5;
      waves.push({ wave, frequency, amplitude, offset, originalXs });
      scene.add(wave);
    }

    // Animation Loop
    const clock = new THREE.Clock();
    const animate = () => {
      const elapsedTime = clock.getElapsedTime();

      waves.forEach(({ wave, frequency, amplitude, offset, originalXs }) => {
        const positions = wave.geometry.attributes.position.array;
        for (let i = 0; i < originalXs.length; i++) {
          const x = originalXs[i];
          positions[i * 3 + 1] =
            Math.sin(x * frequency + elapsedTime + offset) * amplitude;
        }
        wave.geometry.attributes.position.needsUpdate = true;
      });

      renderer.render(scene, camera);
      requestAnimationFrame(animate);
    };

    animate();

    // Handle Resize
    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
      waves.forEach(({ wave }) => {
        wave.geometry.dispose();
        wave.material.dispose();
        scene.remove(wave);
      });
      renderer.dispose();
    };
  }, []);

  const features = [
    {
      title: "Speech Interaction with Effie",
      description:
        "Ask questions verbally and get responses in text or speech—Effie makes communication seamless.",
      link: "/speech-interaction",
    },
    {
      title: "Diagnosis",
      description:
        "Share your medical situation, and Effie will provide a detailed and accurate diagnosis.",
      link: "/diagnosis",
    },
    {
      title: "Talk to Your Document",
      description:
        "Upload your document and ask questions—Effie will help you extract insights instantly.",
      link: "/talk-to-document",
    },
  ];

  const handleNavigation = (link) => {
    window.location.href = link;
  };

  return (
    <div className="relative w-full h-screen overflow-hidden bg-gradient-to-b from-sky-950 via-violet-900 to-sky-600">
      <canvas ref={canvasRef} className="absolute inset-0 mt-48" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        {/* Hero Text */}
        {/* <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-4 animate-fade-in">
          Protect Your IP. Empower Your Conversations.
        </h1>
        <p className="text-base md:text-lg text-gray-200 max-w-2xl mx-auto mb-6 animate-fade-in" style={{ animationDelay: "0.2s" }}>
          No hallucinations. No data leakage. Just secure, high-accuracy agentic AI built for IP-rich businesses.
        </p>
        <p className="text-lg md:text-xl text-[#00d7ff] font-semibold mb-12 animate-fade-in" style={{ animationDelay: "0.4s" }}>
          Your Agentic Companion for{" "}
          <span className="relative inline-block px-2 py-1 rounded-lg bg-white/10 backdrop-blur-md transition-opacity duration-500 group">
            {industry}
            <span className="absolute inset-0 rounded-lg border border-[#00d7ff]/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
          </span>
        </p> */}

        {/* Feature Cards */}
        {/* <div className="flex flex-col md:flex-row gap-6 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`flex-1 bg-white/10 backdrop-blur-md p-6 rounded-lg text-left transition-all duration-500 animate-bounceIn ${
                highlightedCard === index
                  ? "shadow-[0_0_20px_rgba(0,215,255,0.6)] border border-[#00d7ff]/50"
                  : "border border-transparent"
              }`}
              style={{ animationDelay: `${0.6 + index * 0.3}s` }}
            >
              <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
              <p className="text-gray-200 mb-4">{feature.description}</p>
              <button
                onClick={() => handleNavigation(feature.link)}
                className="flex items-center space-x-2 px-4 py-2 bg-cyan-400 text-white font-semibold rounded-lg hover:bg-cyan-500 hover:scale-105 transition-all duration-300 shadow-[0_0_10px_rgba(0,215,255,0.5)] hover:shadow-[0_0_15px_rgba(0,215,255,0.7)]"
              >
                <span>Try Now</span>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          ))}
        </div> */}
      </div>

      {/* Global Styles for Animations */}
      <style>{`
        @keyframes bounceIn {
          0% {
            transform: scale(0.8);
            opacity: 0;
          }
          60% {
            transform: scale(1.05);
            opacity: 1;
          }
          100% {
            transform: scale(1);
          }
        }
        .animate-bounceIn {
          animation: bounceIn 0.8s ease-out forwards;
        }
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default HeroSection;
